





















































































import Vue from 'vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import MStoreFormCheckbox from '@/components/shared/MStoreFormCheckbox.vue';
import { ScriveConfigurationService } from '@/services/scrive/ScriveConfigurationService';
import { ScriveAccountConfigurationModel } from '@/types';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { FormFieldValidation } from '@/mixins';

export default Vue.extend({
  name: 'ScriveAccountConfiguration',
  mixins: [FormFieldValidation],
  data() {
    return {
      isLoading: true,
      isSubmitting: false,
      isClearAuthorisationSubmitting: false,
      isAuthenticationKeySet: false,
      scriveAccountConfigurationModel: {
        username: '',
        password: ''
      } as ScriveAccountConfigurationModel
    };
  },
  methods: {
    async getIsAuthenticationKeySet() {
      this.isAuthenticationKeySet = await ScriveConfigurationService.getIsAuthenticationKeySet();
    },
    async onSubmit(this: any) {
      this.isSubmitting = true;
      try {
        await ScriveConfigurationService.UpdateAccountConfigurationAsync(this.scriveAccountConfigurationModel);
        SnotifyConfiguration.showSuccess('Scrive integration authorised.');
        this.resetScriveAccountConfigurationModel();
      } catch (error) {
        this.$log(error);
      } finally {
        this.isSubmitting = false;
        this.setApplicationDirty(false);
        this.getIsAuthenticationKeySet();
      }
    },
    async onClearAuthorisationButtonClicked() {
      this.isClearAuthorisationSubmitting = true;
      try {
        await ScriveConfigurationService.ClearAccountConfigurationAsync();
        SnotifyConfiguration.showSuccess('Scrive integration authorisation cleared.');
        this.resetScriveAccountConfigurationModel();
      } catch (error) {
        this.$log(error);
      } finally {
        this.isClearAuthorisationSubmitting = false;
        this.getIsAuthenticationKeySet();
      }
    },
    resetScriveAccountConfigurationModel(this: any) {
      this.scriveAccountConfigurationModel = { username: '', password: '' } as ScriveAccountConfigurationModel;
    }
  },
  async mounted() {
    await this.getIsAuthenticationKeySet();
    this.isLoading = false;
  },
  components: {
    MStoreSpinnerButton,
    MStoreFormCheckbox
  }
});
